import gql from 'graphql-tag';

export const CREATE_DTCC_APPLICATION_URL = gql`
  mutation createDTCCApplicationUrl($storeCode: String!, $pageType: PageTypeEnum) {
    synchrony {
      createDTCCApplicationUrl(storeCode: $storeCode, pageType: $pageType) {
        url
        postBackRefId
      }
    }
  }
`;

export const GET_DTCC_APPLICATION_STATUS = gql`
  query getStatus($storeCode: String!) {
    synchrony {
      getStatus(storeCode: $storeCode) {
        status
      }
    }
  }
`;

export const DTCC_PROMOTION_MODAL_MESSAGE = gql`
  query dtccPromotionModalMessage(
    $storeCode: String!
    $orderAmount: BigDecimal!
    $locale: Locale!
  ) {
    storeCheckout(storeCode: $storeCode) {
      cc1PromotionMessage(orderAmount: $orderAmount, locale: $locale) {
        promoData {
          purchaseAPRType
          planDuration
          minOrderAmount
          ISO3LanguageCode
          promotionAPRType
          oneClickModalTerms
          planDescription
          maxOrderAmount
          purchaseAPR
          promotionAPR
          planCode
        }
        userErrors {
          code
          message
        }
      }
    }
  }
`;

export const DTCC_PROMOTION_PLANS = gql`
  query allCC1PromotionPlans(
    $storeCode: String!
  ) {
    storeCheckout(storeCode: $storeCode) {
      allCC1PromotionPlans {
        purchaseAPRType
        planDuration
        minOrderAmount
        ISO3LanguageCode
        promotionAPRType
        oneClickModalTerms
        planDescription
        maxOrderAmount
        purchaseAPR
        promotionAPR
        planCode
      }
    }
  }
`;
